import type { ReviewBlocker } from "@/features/certifications/knowledge-check-flags/types";

export const ATTEMPTS_PAGE_SIZE = 10;

export const ATTEMPT_SKELETON_CARDS = 2;

export const REVIEW_MODAL_WIDTH = 960;

export const REVIEW_BLOCKERS = {
  VERDICTS: "verdicts",
  FEEDBACK: "feedback",
} as const satisfies Record<string, ReviewBlocker>;
